// Institute of Design and Innovation (email idi@unm.edu). //

import cookie from 'js-cookie'
import httpClient from '@/common/httpClient'
import { AxiosError, AxiosResponse } from 'axios'
import store from '@/store/store'
import State from '@/store/state'
import User from '@/models/user'

/**
 * Class with static methods to initialize and destroy session
 */
export default class SessionService {
  /**
   * Returns the current access token's expiration as a Date
   */
  static getAccessTokenExpiration (): number {
    const exp = cookie.get('access_exp')
    return Number(exp)
  }

  /**
   * Returns the current refresh token's expiration as a Date
   */
  static getRefreshTokenExpiration (): number {
    const exp = cookie.get('refresh_exp')
    return Number(exp)
  }

  /**
   * Initializes or refreshes a session
   */
  static initializeSession (): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      // Attempt to get session expiration cookie
      const exp = cookie.get('refresh_exp')

      // If it exists and has not expired
      if (exp && (parseInt(exp) * 1000) > new Date().getSeconds()) {
        httpClient.get('authentication/refresh').then((res: AxiosResponse<User>) => {
          console.log(res.data.id)
          const state = {
            userId: res.data.id,
            firstName: res.data.firstName,
            lastName: res.data.lastName,
            sessionExpiration: this.getRefreshTokenExpiration(),
            accessExpiration: this.getAccessTokenExpiration(),
            permissions: res.data.permissions,
            isAdmin: res.data.isOspStaff,
            outlookUserId: res.data.outlookUserId
          } as State

          store.dispatch('initializeSession', state)
          resolve(true)
        }).catch((err: AxiosError) => {
          if (err.response?.status === 401) {
            resolve(false)
          }
        })
      } else {
        resolve(false)
      }
    })
  }

  /**
   * Request that cookies are removed and redirects to home
   */
  static logOut () {
    httpClient.delete('authentication').then(() => {
      // window.location.href = '/signed-out'
      window.location.href = 'https://login.microsoftonline.com/common/oauth2/logout'
    })
  }

  /**
   * Redirects the user the login screen of the auth provider
   */
  static redirectToLoginProvider () {
    const redirectUrl = `https://login.microsoftonline.com/${process.env.VUE_APP_AZURE_AD_TENANT_ID}/oauth2/v2.0/authorize` +
      '?response_type=code' +
      `&client_id=${process.env.VUE_APP_AZURE_AD_CLIENT_ID}` +
      `&redirect_uri=${process.env.VUE_APP_AZURE_AD_REDIRECT}` +
      '&scope=User.Read'

    window.location.href = redirectUrl
  }
}
